<template>
  <div>
      <DialogParticipants v-if="!dialog"></DialogParticipants>

      <div class="dialog-view" v-else>
        <b-card border-variant="info" bg-variant="default">
          <DialogWall></DialogWall>

          <template v-slot:footer>
            <AddUtterance></AddUtterance>
          </template>
        </b-card>
      </div>


    <!-- <Debug/> -->
    <b-alert variant="danger" v-if="error">{{ error }}</b-alert>
  </div>
</template>

<script>
import DialogParticipants from '@/components/DialogParticipants'
import DialogWall from '@/components/DialogWall'
import AddUtterance from '@/components/AddUtterance'
//import Debug from '@/components/Debug'

export default {
  name: 'Chatinator',
  components: {
    DialogParticipants,
    DialogWall,
    AddUtterance,
    //Debug
  },
  created: function () {
    this.$store.dispatch('authenticate');
  },
  computed: {
    dialog () {
      return this.$store.state.dialog;
    },
    error () {
      return this.$store.state.error;
    }
  }
}
</script>

<style scoped>
  h1 {
    font-family: "Maven Pro";
  }
</style>
